import React from 'react'
import { useIntl } from 'react-intl'

import { codeBoardMap } from '../index'

const BoardDescription = ({ code }: { code: string }) => {
  const intl = useIntl()
  const item = codeBoardMap.get(code)

  return <>{item?.description ? intl.formatMessage({ id: item.description }) : null}</>
}

export default BoardDescription
